import { render } from "./TriggerDescription.vue?vue&type=template&id=02b5cb53&scoped=true"
import script from "./TriggerDescription.vue?vue&type=script&lang=js"
export * from "./TriggerDescription.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b5cb53"]])

export default __exports__